"use client";

import { VariantType } from "@/types/product.type";
import useNumber from "@/hooks/number";
import { Button } from "@mui/material";
import useCart from "@/stores/cart";
import { useRouter } from "next/navigation";
import routes from "@/app.route";
import config from "@/app.config";
import useUnavailableProduct from "@/stores/unavailable-product";
import SparkleEffect from "@/components/sparkle-effect";

export default function ActionBar({ variant }: { variant: VariantType }) {
  const { currency } = useNumber();
  const { loading, addItem } = useCart();
  const router = useRouter();
  const { setOpen } = useUnavailableProduct();

  return (
    <>
      <div className="bg-white sticky bottom-0 p-4 border-t border-zinc-200 z-10">
        <div className="max-w-8xl mx-auto md:px-4">
          <div className="flex items-center md:justify-end justify-between gap-6">
            {Number(variant.price) > 0 && (
              <div className="text-2xl font-semibold">
                {currency(variant.price)}
              </div>
            )}
            <div>
              <SparkleEffect>
                {Number(variant.available) > 0 ? (
                  Number(variant.price) > 0 ? (
                    <Button
                      loading={loading}
                      disabled={loading}
                      onClick={() => {
                        addItem({ ...variant, quantity: "1" });
                        router.push(routes.checkout.url);
                      }}
                      variant="contained"
                    >
                      Buy Now
                    </Button>
                  ) : (
                    <Button
                      href={`tel:${config.contact.primaryPhone}`}
                      target="_blank"
                      variant="outlined"
                    >
                      Enquire Now
                    </Button>
                  )
                ) : (
                  <Button
                    onClick={() => setOpen(`${variant.id}`)}
                    variant="outlined"
                  >
                    Notify Me
                  </Button>
                )}
              </SparkleEffect>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
